'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	REQUIRED_FIELD_EMPTY: 'This is a required field.'
});
